import React, { memo } from 'react';
import { Card, CardBody } from 'reactstrap';

export const CBody = memo((props: React.HTMLProps<HTMLDivElement>) => {
  return (
    <Card>
      <CardBody>{props.children}</CardBody>
    </Card>
  );
});
